import '@babel/polyfill' // NOTE - REQUIRED ON EVERY PAGE
import * as React from 'react'
import withRedux from 'next-redux-wrapper'
import SiteWrapper from '../client/components/SiteWrapper'
import LandingPage from 'pages/LandingPage/LandingPage'
import {makeStore} from '../client/redux'
import {checkSubscriptionCookies} from 'store/actions/site'
import {handleApiUnavailableError} from '../client/utils/errors'
import {setCategories} from 'store/reducers/site'
import {LearnvestApi} from 'client/api/learnvest'

const staticData = {
	"featuredArticles": [{
		"heading": "How to Land Your First Job: A Guide",
		"slug": "how-to-land-your-first-job-a-guide",
		"alternativeHeadline": "How to Land Your First Job: A Guide",
		"category": {
			"name": "First Job"
		},
		"previewImage": {
			"altText": "woman shaking hands at job interview",
			"url": "lv-woman-starting-new-job.jpg"
		}
	}],
	"latestArticles": [{
		"heading": "6 Steps to Building a Strong Relationship With a Work Mentor",
		"slug": "6-steps-to-building-a-strong-relationship-with-a-work-mentor",
		"alternativeHeadline": "6 Steps to Building a Strong Relationship With a Work Mentor",
		"category": {
			"name": "Career Growth"
		},
		"previewImage": {
			"altText": "Work mentee and mentor meeting.",
			"url": "lv-mentee-mentor-meeting-tease-181213.jpg?itok=JfVMLYVz"
		}
	}, {
		"heading": "8 Get-Ahead Questions to Ask Your Boss",
		"slug": "8-get-ahead-questions-to-ask-your-boss",
		"alternativeHeadline": "8 Get-Ahead Questions to Ask Your Boss",
		"category": {
			"name": "Career Growth"
		},
		"previewImage": {
			"altText": "boss hovering over employee's shoulder while she works on laptop",
			"url": "lv-boss-hovering-over-employees-shoulder-tease-180613.jpg?itok=AxZ7AHn6"
		}
	}, {
		"heading": "The Very Best Responses to the Most Basic of Interview Questions",
		"slug": "the-very-best-responses-to-the-most-basic-of-interview-questions",
		"alternativeHeadline": "The Very Best Responses to the Most Basic of Interview Questions",
		"category": {
			"name": "Career Growth"
		},
		"previewImage": {
			"altText": "two men in interview",
			"url": "two-men-in-interview.jpg?itok=BY8cbqYN"
		}
	}, {
		"heading": "How to Start Building an Emergency Fund",
		"slug": "how-to-start-building-an-emergency-fund",
		"alternativeHeadline": "How to Start Building an Emergency Fund",
		"category": {
			"name": "Saving"
		},
		"previewImage": {
			"altText": "woman against a red well",
			"url": "lv-woman-against-red-wall-tease-180625_0.jpg?itok=9Yij-NlU"
		}
	}, {
		"heading": "Ready for a No-Spend Month? Here’s How to Start",
		"slug": "ready-for-a-no-spend-month-heres-how-to-start",
		"alternativeHeadline": "Ready for a No-Spend Month? Here’s How to Start",
		"category": {
			"name": "Saving"
		},
		"previewImage": {
			"altText": "woman planning no-spend month",
			"url": "lv-woman-planning-no-spend-month-tease-190104.jpg?itok=T63derfB"
		}
	}, {
		"heading": "Pain-Free Ways to Start Saving for Retirement",
		"slug": "how-to-start-saving-for-retirement-with-5-pain-free-strategies",
		"alternativeHeadline": "Pain-Free Ways to Start Saving for Retirement",
		"category": {
			"name": "Saving"
		},
		"previewImage": {
			"altText": "young woman looking into distance",
			"url": "young-woman-looking-in-distance-180621.jpg?itok=mqArqbG4"
		}
	}, {
		"heading": "I Was $10K in Debt From Credit Cards. So I Stopped Using Them",
		"slug": "i-was-10k-in-debt-from-credit-cards-so-i-stopped-using-them",
		"alternativeHeadline": "I Was $10K in Debt From Credit Cards. So I Stopped Using Them",
		"category": {
			"name": "Paying off Debt"
		},
		"previewImage": {
			"altText": "Natalia Lusinski in Australia",
			"url": "lv-natalia-lusinski-australia-tease-180220.jpg?itok=I66En1RO"
		}
	}, {
		"heading": "5 Questions to Ask Before Refinancing Your Student Loans",
		"slug": "considering-refinancing-your-student-loans-5-questions-to-ask-first",
		"alternativeHeadline": "5 Questions to Ask Before Refinancing Your Student Loans",
		"category": {
			"name": "Paying off Debt"
		},
		"previewImage": {
			"altText": "graduate standing in front of fountain",
			"url": "woman-in-graduation-cap-1440x810.jpg?itok=8eDLQm8F"
		}
	}, {
		"heading": "How to Raise Your Credit Score",
		"slug": "how-to-raise-your-credit-score",
		"alternativeHeadline": "How to Raise Your Credit Score",
		"category": {
			"name": "Paying off Debt"
		},
		"previewImage": {
			"altText": "Man leaning against blue wall with bicycle",
			"url": "lv-man-leaning-against-blue-wall-with-bicycle-tease-180827.jpg"
		}
	}, {
		"heading": "Take the 4-Week Challenge to Turn Your Finances Around",
		"slug": "save-more-and-build-better-money-habits-with-our-4-week-challenge",
		"alternativeHeadline": "Take the 4-Week Challenge to Turn Your Finances Around",
		"category": {
			"name": "Budgeting"
		},
		"previewImage": {
			"altText": "woman standing by arcade game",
			"url": "lv-woman-standing-by-arcade-game-tease-180615.jpg"
		}
	}, {
		"heading": "Here’s the 1 Change That Will Make Your Budget Fun Again",
		"slug": "heres-the-1-change-that-will-make-your-budget-fun-again",
		"alternativeHeadline": "Here’s the 1 Change That Will Make Your Budget Fun Again",
		"category": {
			"name": "Budgeting"
		},
		"previewImage": {
			"altText": "friends enjoying potluck dinner",
			"url": "lv-planning-ahead-budget-tease-180314.jpg"
		}
	}, {
		"heading": "Classic Money Advice That Stands the Test of Time",
		"slug": "classic-money-advice-that-stands-the-test-of-time",
		"alternativeHeadline": "Classic Money Advice That Stands the Test of Time",
		"category": {
			"name": "Budgeting"
		},
		"previewImage": {
			"altText": "Woman putting money in piggy bank",
			"url": "lv-woman-putting-money-in-piggybank-tease-180624.jpg"
		}
	}],
	"mustReadArticles": [{
		"heading": "How to Start Investing Your Money",
		"slug": "how-to-start-investing-your-money",
		"alternativeHeadline": "How to Start Investing Your Money ",
		"category": {
			"name": "Investing"
		},
		"previewImage": {
			"altText": "Hands holding a tablet looking at stock market fever chart. ",
			"url": "lv-hands-holding-tablet-with-stock-market-chart-tease-180626_0.jpg"
		}
	}],
	"totalArticles": 449,
	"isMobileLayout": "false"
};

class Home extends React.Component {
  // static async getInitialProps ({req, store, query}) {
  //   try {
  //     checkSubscriptionCookies(req, store)
  //     const lvapi = new LearnvestApi(query.ajax)
  //     const landingPageData = await lvapi.fetchLandingPageData()
  //     store.dispatch(setCategories(lvapi.mapCategories(landingPageData.categories)))
  //     return {
  //       featuredArticles: landingPageData.featuredArticles.page,
  //       latestArticles: landingPageData.latestArticles.page,
  //       mustReadArticles: landingPageData.mustReadArticles.page,
  //       totalArticles: landingPageData.latestArticles.total,
  //       isMobileLayout: query.isMobileLayout
  //     }
  //   } catch (e) {
  //     return handleApiUnavailableError(e)
  //   }
  // }

  render () {
    const {
      featuredArticles,
      latestArticles,
      mustReadArticles,
      totalArticles
    } = staticData;
    // } = this.props

    return (
      <SiteWrapper isMobileLayout={this.props.isMobileLayout} apiAvailable={this.props.apiAvailable}>
        <LandingPage totalArticles={totalArticles} featuredArticles={featuredArticles}
          mustReadArticles={mustReadArticles}
          latestArticles={latestArticles} />
      </SiteWrapper>
    )
  }
}

export default withRedux(makeStore)(Home)



// WEBPACK FOOTER //
// ./pages/index.js